export enum TabsLocalStorageModel {
  UpdateQuality = 'UpdateQuality',
}
